import template from './employee_leave_coming_up_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class EmployeeLeaveComingUpHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeeLeaveComingUpHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeLeaveComingUpHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EmployeeLeaveComingUpHelp',
	dialog_class: EmployeeLeaveComingUpHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employee_leave_coming_up_help',
	provider: 'ps'
};
